import React from 'react';
import { productKeys } from '../../../../utils/productHelpers';

/**
 * Pending Account Card component
 * Displays information about an account that is being opened
 * @param {{ pendingAccount: any; products: any[] }} props
 */
const PendingAccountCard = ({ pendingAccount, products }) => {
    const product = products.find((/** @type {any} */ p) => p.id === pendingAccount.productId);
    
    if (!product) {
        return null;
    }

    const issueNumber = product.code === productKeys.NoticeSaver ? product.issueNumber : undefined;

    return (
        <div className="account-slide">
            <div className="pending-account-card">
                <div className="pending-account-card__left">
                    <h4 className="pending-account-card__product">
                        {product.name} {issueNumber && `Issue ${issueNumber}`}
                    </h4>
                </div>
                <div className="pending-account-card__right">
                    <div className="pending-account-card__title">
                        We are opening your account
                    </div>
                    <div className="pending-account-card__detail">
                        You'll see it here and be able to make your first deposit when it's ready.
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PendingAccountCard;
